import React, { useState } from "react";
import { useHistory, NavLink, Link } from "react-router-dom";

import { Permissions, useAuthDataContext } from "modules/auth";
import { useRefToDetectCloseEvents } from "hooks";
import firebase from "firebaseFactory";
import logo from "logo_white.svg";
import { mainNavigationRoutes } from "routes";
import { Padlock } from "components/Padlock";
export interface PageProps {
  isLoading?: boolean;
  children?: React.ReactNode;
  titleButtons?: React.ReactNode;
  titleSupplement?: React.ReactNode;
  status?: string;
}

export const AuthenticatedLayout = ({ children }: PageProps) => {
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const authState = useAuthDataContext();
  const history = useHistory();

  const onSignOut = async () => {
    await firebase.auth().signOut();
    history.push("/");
  };
  const menuRef = useRefToDetectCloseEvents(() => setUserMenuOpen(false));

  return (
    <div>
      <nav className="bg-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <Link to="/">
                  <img
                    className="h-8 w-auto"
                    src={logo}
                    alt="Relectrify logo"
                  />
                </Link>
              </div>
              <div className="hidden md:block">
                <div className="ml-10 flex">
                  {mainNavigationRoutes
                    .filter(
                      (route) =>
                        route.path !== "/admin" &&
                        authState.enforcer.can(route.requiredPermission)
                    )
                    .map((route, index) => (
                      <NavLink
                        key={index}
                        to={route.path}
                        isActive={
                          route.path !== "/"
                            ? undefined
                            : (_, { pathname }) =>
                                pathname === "/" ||
                                pathname.startsWith("/sites/")
                        }
                        activeClassName="text-white bg-gray-900"
                        className="flex-shrink-0 flex items-center mr-4 px-3 py-2 rounded-md text-sm font-medium text-gray-300 hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700"
                      >
                        {route.title}
                      </NavLink>
                    ))}
                </div>
              </div>
            </div>
            <div className="hidden md:block">
              <div className="ml-4 flex items-center md:ml-6">
                {/* <button
                  className="p-1 border-2 border-transparent text-gray-400 rounded-full hover:text-white focus:outline-none focus:text-white focus:bg-gray-700"
                  aria-label="Notifications"
                >
                  <svg
                    className="h-6 w-6"
                    stroke="currentColor"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
                    />
                  </svg>
                </button> */}

                <div className="ml-3 relative">
                  {authState.enforcer.can(Permissions.Users_Manage) && (
                    <NavLink
                      to="/admin"
                      activeClassName="bg-gray-900"
                      className="flex-shrink-0 ml-3 flex items-center rounded-full px-3 py-1 bg-gray-700"
                    >
                      <Padlock />
                      <span className="text-xs font-medium text-gray-100">
                        Administration
                      </span>
                    </NavLink>
                  )}
                </div>
                {/* Profile dropdown */}
                <div className="ml-3 relative">
                  <div>
                    <button
                      onClick={() => setUserMenuOpen(!userMenuOpen)}
                      className="max-w-xs flex items-center text-sm rounded-full text-white focus:outline-none focus:shadow-solid"
                      id="user-menu"
                      aria-label="User menu"
                      aria-haspopup="true"
                    >
                      {authState.user?.photoURL ? (
                        <img
                          className="h-8 w-8 rounded-full"
                          src={authState.user?.photoURL || ""}
                          alt={JSON.stringify(authState.user?.displayName)}
                        />
                      ) : (
                        <i className="material-icons">person</i>
                      )}
                    </button>
                  </div>
                  {userMenuOpen && (
                    <div
                      ref={menuRef}
                      className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg"
                    >
                      <div className="py-1 rounded-md bg-white shadow-xs">
                        {/*<Link to="/profile" className="block px-4 py-2 text-sm hover:bg-gray-100">Your Profile</Link>
                        <Link to="/settings" className="block px-4 py-2 text-sm hover:bg-gray-100">Settings</Link>*/}
                        <button
                          className="block w-full text-left px-4 py-2 text-sm hover:bg-gray-100"
                          onClick={onSignOut}
                        >
                          Sign out
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="-mr-2 flex md:hidden">
              {/* Mobile menu button */}
              <button
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:bg-gray-700 focus:text-white"
              >
                <svg
                  className={`${!mobileMenuOpen ? "block" : "hidden"} h-6 w-6`}
                  stroke="currentColor"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    className="inline-flex"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                  <path
                    className="hidden"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
                <svg
                  className={`${mobileMenuOpen ? "block" : "hidden"} h-6 w-6`}
                  stroke="currentColor"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>

        <div className={`${mobileMenuOpen ? "block" : "hidden"} md:hidden`}>
          <div className="px-2 pt-2 pb-3 sm:px-3">
            {mainNavigationRoutes
              .filter((route) =>
                authState.enforcer.can(route.requiredPermission)
              )
              .map((route, index) => (
                <NavLink
                  key={index}
                  to={route.path}
                  isActive={
                    route.path !== "/"
                      ? undefined
                      : (_, { pathname }) =>
                          pathname === "/" || pathname.startsWith("/site/")
                  }
                  activeClassName="text-white bg-gray-900"
                  className="mb-1 block px-3 py-2 rounded-md text-base font-medium text-gray-300 hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700"
                >
                  {route.title}
                </NavLink>
              ))}
          </div>
          <div className="pt-4 pb-3 border-t border-gray-700">
            <div className="flex items-center px-5">
              <div className="flex-shrink-0">
                <img
                  className="h-8 w-8 rounded-full"
                  src={authState.user?.photoURL || ""}
                  alt={JSON.stringify(authState.user?.displayName)}
                />
              </div>
              <div className="ml-3">
                <div className="text-base font-medium leading-none text-white">
                  {authState.user?.displayName}
                </div>
                <div className="mt-1 text-sm font-medium leading-none text-gray-400">
                  {authState.user?.email}
                </div>
              </div>
            </div>
            <div className="mt-3 px-2">
              <button
                className="mt-1 block px-3 py-2 rounded-md text-base font-medium text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:text-white focus:bg-gray-700"
                onClick={onSignOut}
              >
                Sign out
              </button>
            </div>
          </div>
        </div>
      </nav>
      {children}
    </div>
  );
};
